import { render } from "./UserComponent.vue?vue&type=template&id=1de1ad22&ts=true"
import script from "./User.Service.ts?vue&type=script&lang=ts&external"
export * from "./User.Service.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__